<div class="modal-header">
  <h4 class="modal-title">Edit Delegate</h4>
</div>
<div class="modal-body">
  <section>
    <p id="error-msg" *ngIf="errorMsg !== ''">Error:&nbsp;{{errorMsg}}</p>
  </section>
  <form [formGroup]="delegateForm">
    <div>
      <section class="modal-section1">
        <div class="col-xs-12 col-sm-12 col-md-12 p0 Fields-container">
          <label for="name" class="Fields-label icon-label">Name (Email ID)</label>
          <input type="text" placeholder="Enter Location" [matAutocomplete]="auto" class="Fields-input form-control"
            formControlName="delegateName" (input)="searchApprovers()">
          <mat-autocomplete #auto="matAutocomplete" (optionSelected)="updateMySelection($event)">
            <mat-option [OptionValue]="approver" *ngFor="let approver of searchApproversList"
              [value]="approver.nameEmail">
              {{approver.nameEmail}}
            </mat-option>
          </mat-autocomplete>
          <section *ngIf="f.delegateName.touched && f.delegateName.errors" class="invalid-error">
            <section *ngIf="f.delegateName.errors.required">
              Please select a customer
            </section>
          </section>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 p0 Fields-container">
          <label for="phoneNumber" class="Fields-label icon-label">Phone Number</label>
          <input id="phoneNumber" name="phoneNumber" type="tel" [appMobMask]="'phone'" class="Fields-input"
            placeholder="xxx-xxx-xxxx" formControlName="delegatePhoneNumber" maxlength="12">
          <section *ngIf="f.delegatePhoneNumber.touched && f.delegatePhoneNumber.errors" class="invalid-error">
            <section *ngIf="f.delegatePhoneNumber.errors.pattern">
              Please enter a valid phone number
            </section>
          </section>
        </div>
      </section>
    </div>
  </form>
</div>
<div class="modal-footer">
  <div class="change-request-btngrps">
    <button type="submit" class="btn-primary" data-di-id="#addApprover" (click)="updateDelegate()"
      [disabled]="!submitted ? !delegateForm.valid: 'true'">
      Save delegate
    </button>
    <button type="button" class="btn-secondary" data-dismiss="modal" (click)="cancelPopup()">
      Cancel
    </button>
  </div>
</div>